import React from "react"
import styled from "styled-components"
import {
    Button,
    TableCell,
    ChevronDownIcon,
} from "client/components"

export const ContentColumn = styled.div`
    display: flex;
    flex-direction: column;
    width: fit-content;
    margin-right: 10px;
`
export const ContentItem = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    min-width: 200px;
    padding: 4px 8px;
    margin-bottom: 2px;
    border-radius: 2px;
    background: ${(props) => props.theme.qidModelOptionBackground};
`
export const DeleteContentItemButton = styled.div`
    user-select: none;
    margin-left: 7px;
    cursor: pointer;

    & > i {
        font-weight: bold;
        font-size: ${(props) => props.theme.fontSizes.xs}px;
        color: grey;
        transition: 0.1s ease;

        &:hover {
            color: lightgrey;
            transition: 0.1s ease;
        }
    }
`
export const ContentButton = styled(Button)<{
    fullWidth?: boolean,
    marginTop?: boolean,
}>`
    width: ${(props) => (props.fullWidth ? "100%" : "fit-content")};
    min-width: 200px;
    height: 29px;
    margin-top: ${(props) => (props.marginTop ? "6px" : "0")};
    font-size: 12px;
`
export const TableCellLined = styled(TableCell)<{
    lineThrough?: boolean
    lineCross?: boolean
    lineHalfCross?: boolean
}>`
    position: relative;
    border: none !important;
    
    &:before {
        content: '';
        position: absolute;
        display: "block";
        background: ${(props) => props.theme.qidModelLineTreeBackground};
        width: 1px;
        height: ${(props) => {
        if (props.lineHalfCross) return "50%"
        if (props.lineCross || props.lineThrough) return "100%"
        return "0"
    }};
        left: 40%;
        top: 0;
        z-index: 0;
    }
    
    &:after {
        content: '';
        position: absolute;
        display: ${(props) => ((props.lineCross || props.lineHalfCross) ? "block" : "none")};
        background: ${(props) => props.theme.qidModelLineTreeBackground};
        height: 1px;
        width: 55%;
        left: 40%;
        top: 50%;
        z-index: 0;
    }
`


interface RowCollapseControlProps extends React.HTMLAttributes<HTMLDivElement> {
    collapsed: boolean
}
export const RowCollapseWrapper = styled.div<RowCollapseControlProps>`
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 6px;
    width: 20px;
    height: 20px;
    font-size: 14px;
    line-height: 14px;
    cursor: pointer;
    color: ${(props) => props.theme.qidModelCollapseColor};
    transform: ${(props) => (props.collapsed ? "rotate(-90deg)" : "rotate(0)")};
    transition: ${(props) => props.theme.defaultTransition};
`
export const RowCollapseControl = (props: RowCollapseControlProps) => (
    <RowCollapseWrapper {...props}>
        <ChevronDownIcon />
    </RowCollapseWrapper>
)
